import React, { FC } from "react";
import { Alert } from "react-bootstrap";

interface PropAlert {
  text: string;
  setShow: React.Dispatch<React.SetStateAction<string>>;
}

const AlertErro: FC<PropAlert> = ({ text, setShow }) => {
  if (text) {
    return (
      <Alert
        variant="danger"
        onClose={() => setShow("")}
        dismissible
        
      >
        <p>{text}</p>
      </Alert>
    );
  }
  return <></>;
};

export default AlertErro;
